// client/src/components/common/SkipLink.js
import React from 'react'
import './SkipLink.css'

/**
 * SkipLink - Accessibility component for keyboard navigation
 * 
 * Provides a hidden link that becomes visible when focused,
 * allowing keyboard users to skip directly to main content.
 * This is a WCAG 2.1 AA requirement.
 */
export default function SkipLink({ targetId = 'main-content', text = 'Skip to main content' }) {
  return (
    <a href={`#${targetId}`} className="skip-link">
      {text}
    </a>
  )
}
